import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b10c3a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'toggleIcon',
  props: {
  ticked: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  unSelectedColor: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  id: {
    type: String,
    default: "",
    required: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: __props.id }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("circle", {
        cx: "10",
        cy: "10",
        r: "9.25",
        fill: "none",
        stroke: __props.ticked ? __props.color : __props.unSelectedColor,
        "stroke-width": "1.5"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        class: _normalizeClass(`tick ${__props.ticked ? '' : 'invisible'}`),
        d: "M8.25566 12.1459L6.25003 10.2305L5 11.4392L8.25842 14.4612L15 7.2085L13.7385 5.99969L8.25566 12.1459Z",
        fill: __props.ticked ? __props.color : __props.unSelectedColor
      }, null, 10, _hoisted_4)
    ]))
  ], 8, _hoisted_1))
}
}

})